import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GlobalSearchResultsResponse } from '../../../../core/models/GlobalSearchResultsResponse';
import { FreightDocument } from '../../../../core/models/freight-document/FreightDocument';
import { DisplayableColumns, DocumentsViewMode } from '../view-settings/viewSettings';
import { IPageInfo } from '@iharbeck/ngx-virtual-scroller';

@Component({
  selector: 'app-document-search-results',
  templateUrl: './document-search-results.component.html',
})
export class DocumentSearchResultsComponent {
  DocumentsViewMode = DocumentsViewMode
  @Input({required:true}) searchResponse: GlobalSearchResultsResponse;
  @Input({required:true}) viewMode = DocumentsViewMode.card;
  @Input({required:true}) displayedColumns: DisplayableColumns;

  @Output() vsEndReached = new EventEmitter<IPageInfo>();
  @Output() openPdfClicked = new EventEmitter<FreightDocument>();
  @Output() acceptDeliveryClicked = new EventEmitter<FreightDocument>();
}
